'use client';

import { ReactQueryDevtools as ReactQueryDevtools$1, ReactQueryDevtoolsPanel as ReactQueryDevtoolsPanel$1 } from './devtools.mjs';
var ReactQueryDevtools = process.env.NODE_ENV !== 'development' ? function () {
  return null;
} : ReactQueryDevtools$1;
var ReactQueryDevtoolsPanel = process.env.NODE_ENV !== 'development' ? function () {
  return null;
} : ReactQueryDevtoolsPanel$1;
export { ReactQueryDevtools, ReactQueryDevtoolsPanel };